<template lang="pug">
  .component-create-entity-button
    ModalReveal(ref="editModal")
      template(slot="trigger")
        a.fa-stack.fa-lg(v-if="item == null" )
          i.fa.fa-circle.fa-stack-2x
          i.fa.fa-plus.fa-stack-1x.fa-inverse
        button.button(v-else) Edit
      h2 Document requirement
      .row
        .columns
          label Select entity {{body.entity_type}}
            select(v-model="body.entity_type" )
              option(v-if = "options.length" v-for="value in options" :value="value") {{ value }}

          selectize-category(v-if="body.entity_type ==='VehicleCategory'", @optionSelected="entitySelected", :selected-value="item.entity.id" )
          selectize-plan(v-if="body.entity_type === 'Plan'", @optionSelected="entitySelected", :selected-value="item.entity.id")
          selectize-client-type(v-if="body.entity_type ==='ClientType'", @optionSelected="entitySelected", :selected-value="item.entity.id")
      .row.column
          DocumentRequirementForm(v-model="body")
      .row.columns.text-center
        ActionButton(:action="save") Update
</template>
<script type="text/babel">
import ModalReveal from '../../foundation/ModalReveal'
import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
import SelectizeDocumentType from '../lists/selectize/SelectizeDocumentType'
import SelectizeCategory from '../lists/selectize/SelectizeCategory'
import SelectizePlan from '../lists/selectize/SelectizePlan'
import SelectizeClientType from "../lists/selectize/SelectizeClientType";
import ActionButton from "../ActionButton.vue";
import {EventBus} from "../../../../eventBus";
import DocumentRequirementForm from "../../forms/DocumentRequirementForm.vue";

export default {
  name: 'EditDocumentRequirementButtonModal',
  components: {
    DocumentRequirementForm,
    ActionButton, SelectizeClientType, SelectizePlan, SelectizeCategory, SelectizeDocumentType, ModalReveal},
  data() {
    return {
      entityId: null,
      entity_type: null,

      body: {
        entity_type: this.item.entity_class.replace("App\\Models\\", ""),
        entity_id: null,//this.item.entity_id,
        document_type_id: this.item.document_type.id,
        document_group: this.item.document_group,
        minimum_document_emission_years: this.item.minimum_document_emission_years,
        minimum_driver_age: this.item.minimum_driver_age,
        minimum_driver_registration_seniority: this.item.minimum_driver_registration_seniority,
        minimum_bookings_in_last_days: this.item.minimum_bookings_in_last_days,
        minimum_client_invoiced: this.item.minimum_client_invoiced,
        maximum_client_failed_transactions: this.item.maximum_client_failed_transactions,
      },
      options: []
    }
  },
  created() {
    this.loadEntity()
  },
  methods: {
    documentTypeSelected(obj) {
      this.body.document_type_id = obj.id
    },
    entitySelected(obj) {
      this.body.entity_id = obj.id
      this.body.entity_type = this.capitalize(this.body.entity_type)
    },

    capitalize(s) {
      return s.split('_').map(x => x.charAt(0).toUpperCase() + x.slice(1)).join('')
    },
    loadEntity() {
      KeplerBackofficeSdk.documentRequirements.entityAllowed().entityList((data) => {
        this.options = data

      })
    },
    save() {
      return KeplerBackofficeSdk.documentRequirements.select(this.item).edit(this.body, () => {
        EventBus.$emit('reload-list')
        this.$refs.editModal.close()
      })
    }
  },
  computed: {},
  props: ['item']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// EditDocumentRequirementButtonModal.vue?1c8c8d0d